<section class="collapsible">
  <button class="collapse" (click)="toggle()">
    <h2 class="offerHeader">{{ offerTitle() | translate }}</h2>
    <div>
      <img
        src="assets/img/arrow.png"
        [@collapse]="arrowed"
        style="z-index: 2"
      />
      <img
        src="assets/img/arrowInactive.png"
        [@collapse]="arrowedInactive"
        style="z-index: 1"
      />
    </div>
  </button>
  @if(descHeaderHighlightA()){
  <div class="content" [@collapse]="collapsed">
    @if (descHeaderHighlight()){
    <button class="collapse offerSubheaderButton" (click)="toggle1()">
      <h2 class="offerSubheader">
        {{ descHeaderHighlight() || "" | translate }}
      </h2>
      <div>
        <img
          src="assets/img/arrow.png"
          [@collapse]="arrowed1"
          style="z-index: 2"
        />
        <img
          src="assets/img/arrowInactive.png"
          [@collapse]="arrowedInactive1"
          style="z-index: 1"
        />
      </div>
    </button>
    <div
      class="frame"
      [@collapse]="collapsed1"
      [ngClass]="{ inactive: collapsed1 }"
    >
      <div class="frameContent" [@collapse]="!desc">
        <app-offer-description
          [headerHighlight]="descHeaderHighlight()"
          [header]="descHeaderHighlight1()"
          [descHeader]="descHeader()"
          [descText1]="descText1()"
          [descText2]="descText2()"
          [logo1]="descLogo1()"
          [logo2]="descLogo2()"
          [logo3]="descLogo3()"
          [logo4]="descLogo4()"
          [logo5]="descLogo5()"
        ></app-offer-description>
      </div>
      @if (abilHeader()){
      <div class="frameContent" [@collapse]="!abil">
        <app-offer-abilities
          [headerHighlight]="abilHeaderHighlight()"
          [header]="abilHeader()"
          [bold1]="abilBold1()"
          [text1]="abilText1()"
          [bold2]="abilBold2()"
          [text2]="abilText2()"
          [bold3]="abilBold3()"
          [text3]="abilText3()"
          [bold4]="abilBold4()"
          [text4]="abilText4()"
          [bold5]="abilBold5()"
          [text5]="abilText5()"
        ></app-offer-abilities>
      </div>
      } @if (prosHeader()){
      <div class="frameContent" [@collapse]="!pros">
        <app-offer-pros
          [header]="prosHeader()"
          [bold1]="prosBold1()"
          [text1]="prosText1()"
          [bold2]="prosBold2()"
          [text2]="prosText2()"
          [bold3]="prosBold3()"
          [text3]="prosText3()"
          [bold4]="prosBold4()"
          [text4]="prosText4()"
        ></app-offer-pros>
      </div>
      } @if (howHeader()){
      <div class="frameContent" [@collapse]="!how">
        <app-offer-how
          [header]="howHeader()"
          [bold1]="howBold1()"
          [text1]="howText1()"
          [bold2]="howBold2()"
          [text2]="howText2()"
          [bold3]="howBold3()"
          [text3]="howText3()"
          [bold4]="howBold4()"
          [text4]="howText4()"
        ></app-offer-how>
      </div>
      } @if (techHeader()) {
      <div class="frameContent" [@collapse]="!tech">
        <app-offer-tech
          [header]="techHeader()"
          [bold1]="techBold1()"
          [text1]="techText1()"
          [bold2]="techBold2()"
          [text2]="techText2()"
          [bold3]="techBold3()"
          [text3]="techText3()"
          [bold4]="techBold4()"
          [text4]="techText4()"
        ></app-offer-tech>
      </div>
      } @if (forHeader()){
      <div class="frameContent" [@collapse]="!for">
        <app-offer-for
          [header]="forHeader()"
          [subheader]="forSubheader()"
          [text1]="forText1()"
          [text2]="forText2()"
          [text3]="forText3()"
          [text4]="forText4()"
          [bold1]="forBold1()"
          [bold2]="forBold2()"
          [bold3]="forBold3()"
          [bold4]="forBold4()"
        ></app-offer-for>
      </div>
      } @if(checkHeader()){
      <div class="frameContent" [@collapse]="!check">
        <app-offer-check
          [header]="checkHeader()"
          [bold1]="checkBold1()"
          [text1]="checkText1()"
          [link1]="checkLink1()"
          [bold2]="checkBold2()"
          [text2]="checkText2()"
          [link2]="checkLink2()"
        ></app-offer-check>
      </div>
      }

      <!-- <app-offer
          desc="{desc}"
          abil="{abil}"
          pros="{pros}"
          how="{how}"
          tech="{tech}"
          for="{for}"
          check="{check}"
        ></app-offer> -->
      <div class="frameNav">
        @if (descHeader()){
        <button class="frameMenu" (click)="description()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.description" | translate }}
          </p>
          <div class="offer-btn">
            <!-- <svg
                xmlns:dc="http://purl.org/dc/elements/1.1/"
                xmlns:cc="http://creativecommons.org/ns#"
                xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                xmlns:svg="http://www.w3.org/2000/svg"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                [@collapse]="desc"
              >
                <path
                  style="
                    fill: none;
                    stroke: #a8a8a8;
                    stroke-width: 1.5;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 4;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                    stop-color: #000000;
                  "
                  d="M -22.385176,135.39702 H 116.85366"
                  id="path835"
                />
                <path
                  style="
                    fill: none;
                    stroke: #a8a8a8;
                    stroke-width: 1.5;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 4;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                    stop-color: #000000;
                  "
                  d="M 142.71652,135.39702 H 281.95536"
                  id="path839"
                />
                <ellipse
                  style="
                    fill: none;
                    stroke: #ffa11f;
                    stroke-width: 0.999998;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-opacity: 1;
                    stop-color: #000000;
                  "
                  id="path833"
                  cx="129.78867"
                  cy="135.39702"
                  rx="12.681542"
                  ry="12.527542"
                />
              </svg> -->
            <img src="assets/img/frameMenuActive.png" [@collapse]="!desc" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="desc" />
          </div>
        </button>
        } @if (abilHeader()){
        <button class="frameMenu" (click)="abilities()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.abilities" | translate }}
          </p>
          <div
            class="offer-btn"
            style="display: flex; justify-content: center; align-items: center"
          >
            <img src="assets/img/frameMenuActive.png" [@collapse]="!abil" />
            <img
              src="assets/img/frameMenuInactive.png"
              [@collapse]="abil"
              class="frameMenuInactive"
            />
            <!-- <svg
                height="2"
                width="auto"
                xmlns="http://www.w3.org/2000/svg"
                [@collapse]="abil"
                style="z-index: 1"
              >
                <line
                  x1="0"
                  y1="0"
                  x2="30"
                  y2="0"
                  style="stroke: #a8a8a8; stroke-width: 2"
                />
              </svg> -->
          </div>
        </button>
        } @if (prosHeader()){
        <button class="frameMenu" (click)="prosfun()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.pros" | translate }}
          </p>
          <div class="offer-btn">
            <img src="assets/img/frameMenuActive.png" [@collapse]="!pros" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="pros" />
          </div>
        </button>
        } @if (howHeader()){
        <button class="frameMenu" (click)="howfun()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.how" | translate }}
          </p>
          <div class="offer-btn">
            <img src="assets/img/frameMenuActive.png" [@collapse]="!how" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="how" />
          </div>
        </button>
        } @if (techHeader()) {
        <button class="frameMenu" (click)="techfun()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.tech1" | translate }}<br />
            {{ "offers.collapsible.tech2" | translate }}
          </p>
          <div class="offer-btn">
            <img src="assets/img/frameMenuActive.png" [@collapse]="!tech" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="tech" />
          </div></button
        >} @if(forHeader()){
        <button class="frameMenu" (click)="forfun()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.for" | translate }}
          </p>
          <div class="offer-btn">
            <img src="assets/img/frameMenuActive.png" [@collapse]="!for" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="for" />
          </div>
        </button>
        } @if (checkHeader()){
        <button class="frameMenu" (click)="checkfun()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.check" | translate }}
          </p>
          <div class="offer-btn">
            <img src="assets/img/frameMenuActive.png" [@collapse]="!check" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="check" />
          </div>
        </button>
        }
      </div>
    </div>
    } @if (descHeaderHighlightA()) {

    <button class="collapse offerSubheaderButton" (click)="toggleA()">
      <h2 class="offerSubheader">
        {{ descHeaderHighlightA() || "" | translate }}
      </h2>
      <div>
        <img
          src="assets/img/arrow.png"
          [@collapse]="arrowedA"
          style="z-index: 2"
        />
        <img
          src="assets/img/arrowInactive.png"
          [@collapse]="arrowedInactiveA"
          style="z-index: 1"
        />
      </div>
    </button>
    <div
      class="frame"
      [@collapse]="collapsedA"
      [ngClass]="{ inactive: collapsedA }"
    >
      <div class="frameContent" [@collapse]="!descA">
        <app-offer-description
          [headerHighlight]="descHeaderHighlightA()"
          [header]="descHeaderHighlight1A()"
          [descHeader]="descHeaderA()"
          [descText1]="descText1A()"
          [descText2]="descText2A()"
          [logo1]="descLogo1A()"
          [logo2]="descLogo2A()"
          [logo3]="descLogo3A()"
          [logo4]="descLogo4A()"
          [logo5]="descLogo5A()"
        ></app-offer-description>
      </div>
      @if (abilHeaderA()){
      <div class="frameContent" [@collapse]="!abilA">
        <app-offer-abilities
          [headerHighlight]="abilHeaderHighlightA()"
          [header]="abilHeaderA()"
          [bold1]="abilBold1A()"
          [text1]="abilText1A()"
          [bold2]="abilBold2A()"
          [text2]="abilText2A()"
          [bold3]="abilBold3A()"
          [text3]="abilText3A()"
          [bold4]="abilBold4A()"
          [text4]="abilText4A()"
          [bold5]="abilBold5A()"
          [text5]="abilText5A()"
        ></app-offer-abilities>
      </div>
      } @if (prosHeaderA()){
      <div class="frameContent" [@collapse]="!prosA">
        <app-offer-pros
          [header]="prosHeaderA()"
          [bold1]="prosBold1A()"
          [text1]="prosText1A()"
          [bold2]="prosBold2A()"
          [text2]="prosText2A()"
          [bold3]="prosBold3A()"
          [text3]="prosText3A()"
          [bold4]="prosBold4A()"
          [text4]="prosText4A()"
        ></app-offer-pros>
      </div>
      }
      <div class="frameContent" [@collapse]="!howA">
        <app-offer-how
          [header]="howHeaderA()"
          [bold1]="howBold1A()"
          [text1]="howText1A()"
          [bold2]="howBold2A()"
          [text2]="howText2A()"
          [bold3]="howBold3A()"
          [text3]="howText3A()"
          [bold4]="howBold4A()"
          [text4]="howText4A()"
        ></app-offer-how>
      </div>
      @if (techHeaderA()){
      <div class="frameContent" [@collapse]="!techA">
        <app-offer-tech
          [header]="techHeaderA()"
          [bold1]="techBold1A()"
          [text1]="techText1A()"
          [bold2]="techBold2A()"
          [text2]="techText2A()"
          [bold3]="techBold3A()"
          [text3]="techText3A()"
          [bold4]="techBold4A()"
          [text4]="techText4A()"
        ></app-offer-tech>
      </div>
      } @if (forHeaderA()){
      <div class="frameContent" [@collapse]="!forA">
        <app-offer-for
          [header]="forHeaderA()"
          [text1]="forText1A()"
          [text2]="forText2A()"
          [text3]="forText3A()"
          [text4]="forText4A()"
          [bold1]="forBold1A()"
          [bold2]="forBold2A()"
          [bold3]="forBold3A()"
          [bold4]="forBold4A()"
        ></app-offer-for>
      </div>
      } @if (checkHeaderA()){
      <div class="frameContent" [@collapse]="!checkA">
        <app-offer-check
          [header]="checkHeaderA()"
          [bold1]="checkBold1A()"
          [text1]="checkText1A()"
          [link1]="checkLink1A()"
          [bold2]="checkBold2A()"
          [text2]="checkText2A()"
          [link2]="checkLink2A()"
        ></app-offer-check>
      </div>
      }

      <!-- <app-offer
          desc="{desc}"
          abil="{abil}"
          pros="{pros}"
          how="{how}"
          tech="{tech}"
          for="{for}"
          check="{check}"
        ></app-offer> -->
      <div class="frameNav">
        @if (descHeaderHighlightA()){
        <button class="frameMenu" (click)="descriptionA()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.description" | translate }}
          </p>
          <div>
            <!-- <svg
                xmlns:dc="http://purl.org/dc/elements/1.1/"
                xmlns:cc="http://creativecommons.org/ns#"
                xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                xmlns:svg="http://www.w3.org/2000/svg"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                [@collapse]="desc"
              >
                <path
                  style="
                    fill: none;
                    stroke: #a8a8a8;
                    stroke-width: 1.5;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 4;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                    stop-color: #000000;
                  "
                  d="M -22.385176,135.39702 H 116.85366"
                  id="path835"
                />
                <path
                  style="
                    fill: none;
                    stroke: #a8a8a8;
                    stroke-width: 1.5;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 4;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                    stop-color: #000000;
                  "
                  d="M 142.71652,135.39702 H 281.95536"
                  id="path839"
                />
                <ellipse
                  style="
                    fill: none;
                    stroke: #ffa11f;
                    stroke-width: 0.999998;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-opacity: 1;
                    stop-color: #000000;
                  "
                  id="path833"
                  cx="129.78867"
                  cy="135.39702"
                  rx="12.681542"
                  ry="12.527542"
                />
              </svg> -->
            <img src="assets/img/frameMenuActive.png" [@collapse]="!descA" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="descA" />
          </div>
        </button>
        } @if (abilHeaderA()){
        <button class="frameMenu" (click)="abilitiesA()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.abilities" | translate }}
          </p>
          <div
            style="display: flex; justify-content: center; align-items: center"
          >
            <img src="assets/img/frameMenuActive.png" [@collapse]="!abilA" />
            <img
              src="assets/img/frameMenuInactive.png"
              [@collapse]="abilA"
              class="frameMenuInactive"
            />
            <!-- <svg
                height="2"
                width="auto"
                xmlns="http://www.w3.org/2000/svg"
                [@collapse]="abil"
                style="z-index: 1"
              >
                <line
                  x1="0"
                  y1="0"
                  x2="30"
                  y2="0"
                  style="stroke: #a8a8a8; stroke-width: 2"
                />
              </svg> -->
          </div>
        </button>
        } @if (prosHeaderA()){
        <button class="frameMenu" (click)="prosfunA()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.pros" | translate }}
          </p>
          <div>
            <img src="assets/img/frameMenuActive.png" [@collapse]="!prosA" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="prosA" />
          </div>
        </button>
        }
        <button class="frameMenu" (click)="howfunA()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.how" | translate }}
          </p>
          <div>
            <img src="assets/img/frameMenuActive.png" [@collapse]="!howA" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="howA" />
          </div>
        </button>
        @if (techHeaderA()){
        <button class="frameMenu" (click)="techfunA()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.tech1" | translate }}<br />
            {{ "offers.collapsible.tech2" | translate }}
          </p>
          <div>
            <img src="assets/img/frameMenuActive.png" [@collapse]="!techA" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="techA" />
          </div>
        </button>
        } @if (forHeaderA()){
        <button class="frameMenu" (click)="forfunA()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.for" | translate }}
          </p>
          <div>
            <img src="assets/img/frameMenuActive.png" [@collapse]="!forA" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="forA" />
          </div>
        </button>
        } @if (checkHeaderA()){
        <button class="frameMenu" (click)="checkfunA()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.check" | translate }}
          </p>
          <div>
            <img src="assets/img/frameMenuActive.png" [@collapse]="!checkA" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="checkA" />
          </div>
        </button>
        }
      </div>
    </div>
    } @if (descHeaderHighlightB()) {

    <button class="collapse offerSubheaderButton" (click)="toggleB()">
      <h2 class="offerSubheader">
        {{ descHeaderHighlightB() || "" | translate }}
      </h2>
      <div>
        <img
          src="assets/img/arrow.png"
          [@collapse]="arrowedB"
          style="z-index: 2"
        />
        <img
          src="assets/img/arrowInactive.png"
          [@collapse]="arrowedInactiveB"
          style="z-index: 1"
        />
      </div>
    </button>
    <div
      class="frame"
      [@collapse]="collapsedB"
      [ngClass]="{ inactive: collapsedB }"
    >
      <div class="frameContent" [@collapse]="!descB">
        <app-offer-description
          [headerHighlight]="descHeaderHighlightB()"
          [header]="descHeaderHighlight1B()"
          [descHeader]="descHeaderB()"
          [descText1]="descText1B()"
          [descText2]="descText2B()"
          [logo1]="descLogo1B()"
          [logo2]="descLogo2B()"
          [logo3]="descLogo3B()"
          [logo4]="descLogo4B()"
          [logo5]="descLogo5B()"
        ></app-offer-description>
      </div>
      @if(abilHeaderB()){
      <div class="frameContent" [@collapse]="!abilB">
        <app-offer-abilities
          [headerHighlight]="abilHeaderHighlightB()"
          [header]="abilHeaderB()"
          [bold1]="abilBold1B()"
          [text1]="abilText1B()"
          [bold2]="abilBold2B()"
          [text2]="abilText2B()"
          [bold3]="abilBold3B()"
          [text3]="abilText3B()"
          [bold4]="abilBold4B()"
          [text4]="abilText4B()"
          [bold5]="abilBold5B()"
          [text5]="abilText5B()"
        ></app-offer-abilities>
      </div>
      } @if(prosHeaderB()){
      <div class="frameContent" [@collapse]="!prosB">
        <app-offer-pros
          [header]="prosHeaderB()"
          [bold1]="prosBold1B()"
          [text1]="prosText1B()"
          [bold2]="prosBold2B()"
          [text2]="prosText2B()"
          [bold3]="prosBold3B()"
          [text3]="prosText3B()"
          [bold4]="prosBold4B()"
          [text4]="prosText4B()"
        ></app-offer-pros>
      </div>
      }
      <div class="frameContent" [@collapse]="!howB">
        <app-offer-how
          [header]="howHeaderB()"
          [bold1]="howBold1B()"
          [text1]="howText1B()"
          [bold2]="howBold2B()"
          [text2]="howText2B()"
          [bold3]="howBold3B()"
          [text3]="howText3B()"
          [bold4]="howBold4B()"
          [text4]="howText4B()"
        ></app-offer-how>
      </div>
      @if (techHeaderB()){
      <div class="frameContent" [@collapse]="!techB">
        <app-offer-tech
          [header]="techHeaderB()"
          [bold1]="techBold1B()"
          [text1]="techText1B()"
          [bold2]="techBold2B()"
          [text2]="techText2B()"
          [bold3]="techBold3B()"
          [text3]="techText3B()"
          [bold4]="techBold4B()"
          [text4]="techText4B()"
        ></app-offer-tech>
      </div>
      } @if (forHeaderB()){
      <div class="frameContent" [@collapse]="!forB">
        <app-offer-for
          [header]="forHeaderB()"
          [text1]="forText1B()"
          [text2]="forText2B()"
          [text3]="forText3B()"
          [text4]="forText4B()"
          [bold1]="forBold1B()"
          [bold2]="forBold2B()"
          [bold3]="forBold3B()"
          [bold4]="forBold4B()"
        ></app-offer-for>
      </div>
      } @if (checkHeaderB()){
      <div class="frameContent" [@collapse]="!checkB">
        <app-offer-check
          [header]="checkHeaderB()"
          [bold1]="checkBold1B()"
          [text1]="checkText1B()"
          [link1]="checkLink1B()"
          [bold2]="checkBold2B()"
          [text2]="checkText2B()"
          [link2]="checkLink2B()"
        ></app-offer-check>
      </div>
      }
      <!-- <app-offer
          desc="{desc}"
          abil="{abil}"
          pros="{pros}"
          how="{how}"
          tech="{tech}"
          for="{for}"
          check="{check}"
        ></app-offer> -->
      <div class="frameNav">
        @if (descHeaderHighlightB()){
        <button class="frameMenu" (click)="descriptionB()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.description" | translate }}
          </p>
          <div>
            <!-- <svg
                xmlns:dc="http://purl.org/dc/elements/1.1/"
                xmlns:cc="http://creativecommons.org/ns#"
                xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                xmlns:svg="http://www.w3.org/2000/svg"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                [@collapse]="desc"
              >
                <path
                  style="
                    fill: none;
                    stroke: #a8a8a8;
                    stroke-width: 1.5;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 4;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                    stop-color: #000000;
                  "
                  d="M -22.385176,135.39702 H 116.85366"
                  id="path835"
                />
                <path
                  style="
                    fill: none;
                    stroke: #a8a8a8;
                    stroke-width: 1.5;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 4;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                    stop-color: #000000;
                  "
                  d="M 142.71652,135.39702 H 281.95536"
                  id="path839"
                />
                <ellipse
                  style="
                    fill: none;
                    stroke: #ffa11f;
                    stroke-width: 0.999998;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-opacity: 1;
                    stop-color: #000000;
                  "
                  id="path833"
                  cx="129.78867"
                  cy="135.39702"
                  rx="12.681542"
                  ry="12.527542"
                />
              </svg> -->
            <img src="assets/img/frameMenuActive.png" [@collapse]="!descB" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="descB" />
          </div>
        </button>
        } @if (abilHeaderB()){
        <button class="frameMenu" (click)="abilitiesB()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.abilities" | translate }}
          </p>
          <div
            style="display: flex; justify-content: center; align-items: center"
          >
            <img src="assets/img/frameMenuActive.png" [@collapse]="!abilB" />
            <img
              src="assets/img/frameMenuInactive.png"
              [@collapse]="abilB"
              class="frameMenuInactive"
            />
            <!-- <svg
                height="2"
                width="auto"
                xmlns="http://www.w3.org/2000/svg"
                [@collapse]="abil"
                style="z-index: 1"
              >
                <line
                  x1="0"
                  y1="0"
                  x2="30"
                  y2="0"
                  style="stroke: #a8a8a8; stroke-width: 2"
                />
              </svg> -->
          </div>
        </button>
        } @if (prosHeaderB()){
        <button class="frameMenu" (click)="prosfunB()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.pros" | translate }}
          </p>
          <div>
            <img src="assets/img/frameMenuActive.png" [@collapse]="!prosB" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="prosB" />
          </div>
        </button>
        }
        <button class="frameMenu" (click)="howfunB()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.how" | translate }}
          </p>
          <div>
            <img src="assets/img/frameMenuActive.png" [@collapse]="!howB" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="howB" />
          </div>
        </button>
        @if (techHeaderB()){
        <button class="frameMenu" (click)="techfunB()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.tech1" | translate }}<br />
            {{ "offers.collapsible.tech2" | translate }}
          </p>
          <div>
            <img src="assets/img/frameMenuActive.png" [@collapse]="!techB" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="techB" />
          </div>
        </button>
        } @if (forHeaderB()){
        <button class="frameMenu" (click)="forfunB()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.for" | translate }}
          </p>
          <div>
            <img src="assets/img/frameMenuActive.png" [@collapse]="!forB" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="forB" />
          </div>
        </button>
        } @if (checkHeaderB()){
        <button class="frameMenu" (click)="checkfunB()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.check" | translate }}
          </p>
          <div>
            <img src="assets/img/frameMenuActive.png" [@collapse]="!checkB" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="checkB" />
          </div>
        </button>
        }
      </div>
    </div>
    }
  </div>

  }@else {
  <div class="content" [@collapse]="collapsed">
    @if (descHeaderHighlight()){
    <div class="frame">
      <div class="frameContent" [@collapse]="!desc">
        <app-offer-description
          [headerHighlight]="descHeaderHighlight()"
          [header]="descHeaderHighlight1()"
          [descHeader]="descHeader()"
          [descText1]="descText1()"
          [descText2]="descText2()"
          [logo1]="descLogo1()"
          [logo2]="descLogo2()"
          [logo3]="descLogo3()"
          [logo4]="descLogo4()"
          [logo5]="descLogo5()"
        ></app-offer-description>
      </div>
      @if (abilHeader()){
      <div class="frameContent" [@collapse]="!abil">
        <app-offer-abilities
          [headerHighlight]="abilHeaderHighlight()"
          [header]="abilHeader()"
          [bold1]="abilBold1()"
          [text1]="abilText1()"
          [bold2]="abilBold2()"
          [text2]="abilText2()"
          [bold3]="abilBold3()"
          [text3]="abilText3()"
          [bold4]="abilBold4()"
          [text4]="abilText4()"
          [bold5]="abilBold5()"
          [text5]="abilText5()"
        ></app-offer-abilities>
      </div>
      } @if (prosHeader()){
      <div class="frameContent" [@collapse]="!pros">
        <app-offer-pros
          [header]="prosHeader()"
          [bold1]="prosBold1()"
          [text1]="prosText1()"
          [bold2]="prosBold2()"
          [text2]="prosText2()"
          [bold3]="prosBold3()"
          [text3]="prosText3()"
          [bold4]="prosBold4()"
          [text4]="prosText4()"
        ></app-offer-pros>
      </div>
      } @if (howHeader()){
      <div class="frameContent" [@collapse]="!how">
        <app-offer-how
          [header]="howHeader()"
          [bold1]="howBold1()"
          [text1]="howText1()"
          [bold2]="howBold2()"
          [text2]="howText2()"
          [bold3]="howBold3()"
          [text3]="howText3()"
          [bold4]="howBold4()"
          [text4]="howText4()"
        ></app-offer-how>
      </div>
      } @if (techHeader()) {
      <div class="frameContent" [@collapse]="!tech">
        <app-offer-tech
          [header]="techHeader()"
          [bold1]="techBold1()"
          [text1]="techText1()"
          [bold2]="techBold2()"
          [text2]="techText2()"
          [bold3]="techBold3()"
          [text3]="techText3()"
          [bold4]="techBold4()"
          [text4]="techText4()"
        ></app-offer-tech>
      </div>
      } @if (forHeader()){
      <div class="frameContent" [@collapse]="!for">
        <app-offer-for
          [header]="forHeader()"
          [subheader]="forSubheader()"
          [text1]="forText1()"
          [text2]="forText2()"
          [text3]="forText3()"
          [text4]="forText4()"
          [bold1]="forBold1()"
          [bold2]="forBold2()"
          [bold3]="forBold3()"
          [bold4]="forBold4()"
        ></app-offer-for>
      </div>
      } @if(checkHeader()){
      <div class="frameContent" [@collapse]="!check">
        <app-offer-check
          [header]="checkHeader()"
          [bold1]="checkBold1()"
          [text1]="checkText1()"
          [link1]="checkLink1()"
          [bold2]="checkBold2()"
          [text2]="checkText2()"
          [link2]="checkLink2()"
        ></app-offer-check>
      </div>
      }

      <!-- <app-offer
          desc="{desc}"
          abil="{abil}"
          pros="{pros}"
          how="{how}"
          tech="{tech}"
          for="{for}"
          check="{check}"
        ></app-offer> -->
      <div class="frameNav">
        @if (descHeader()){
        <button class="frameMenu" (click)="description()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.description" | translate }}
          </p>
          <div class="offer-btn">
            <!-- <svg
                xmlns:dc="http://purl.org/dc/elements/1.1/"
                xmlns:cc="http://creativecommons.org/ns#"
                xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                xmlns:svg="http://www.w3.org/2000/svg"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                [@collapse]="desc"
              >
                <path
                  style="
                    fill: none;
                    stroke: #a8a8a8;
                    stroke-width: 1.5;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 4;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                    stop-color: #000000;
                  "
                  d="M -22.385176,135.39702 H 116.85366"
                  id="path835"
                />
                <path
                  style="
                    fill: none;
                    stroke: #a8a8a8;
                    stroke-width: 1.5;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 4;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                    stop-color: #000000;
                  "
                  d="M 142.71652,135.39702 H 281.95536"
                  id="path839"
                />
                <ellipse
                  style="
                    fill: none;
                    stroke: #ffa11f;
                    stroke-width: 0.999998;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-opacity: 1;
                    stop-color: #000000;
                  "
                  id="path833"
                  cx="129.78867"
                  cy="135.39702"
                  rx="12.681542"
                  ry="12.527542"
                />
              </svg> -->
            <img src="assets/img/frameMenuActive.png" [@collapse]="!desc" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="desc" />
          </div>
        </button>
        } @if (abilHeader()){
        <button class="frameMenu" (click)="abilities()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.abilities" | translate }}
          </p>
          <div
            class="offer-btn"
            style="display: flex; justify-content: center; align-items: center"
          >
            <img src="assets/img/frameMenuActive.png" [@collapse]="!abil" />
            <img
              src="assets/img/frameMenuInactive.png"
              [@collapse]="abil"
              class="frameMenuInactive"
            />
            <!-- <svg
                height="2"
                width="auto"
                xmlns="http://www.w3.org/2000/svg"
                [@collapse]="abil"
                style="z-index: 1"
              >
                <line
                  x1="0"
                  y1="0"
                  x2="30"
                  y2="0"
                  style="stroke: #a8a8a8; stroke-width: 2"
                />
              </svg> -->
          </div>
        </button>
        } @if (prosHeader()){
        <button class="frameMenu" (click)="prosfun()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.pros" | translate }}
          </p>
          <div class="offer-btn">
            <img src="assets/img/frameMenuActive.png" [@collapse]="!pros" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="pros" />
          </div>
        </button>
        } @if (howHeader()){
        <button class="frameMenu" (click)="howfun()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.how" | translate }}
          </p>
          <div class="offer-btn">
            <img src="assets/img/frameMenuActive.png" [@collapse]="!how" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="how" />
          </div>
        </button>
        } @if (techHeader()) {
        <button class="frameMenu" (click)="techfun()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.tech1" | translate }}<br />
            {{ "offers.collapsible.tech2" | translate }}
          </p>
          <div class="offer-btn">
            <img src="assets/img/frameMenuActive.png" [@collapse]="!tech" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="tech" />
          </div></button
        >} @if(forHeader()){
        <button class="frameMenu" (click)="forfun()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.for" | translate }}
          </p>
          <div class="offer-btn">
            <img src="assets/img/frameMenuActive.png" [@collapse]="!for" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="for" />
          </div>
        </button>
        } @if (checkHeader()){
        <button class="frameMenu" (click)="checkfun()">
          <p class="frameMenuCaption">
            {{ "offers.collapsible.check" | translate }}
          </p>
          <div class="offer-btn">
            <img src="assets/img/frameMenuActive.png" [@collapse]="!check" />
            <img src="assets/img/frameMenuInactive.png" [@collapse]="check" />
          </div>
        </button>
        }
      </div>
    </div>
    }
  </div>
  }
</section>
